import type { SxProps, Theme } from "@mui/material/styles";

import type { FloatingTextFieldState } from "./FloatingTextField.types";

export const root =
  (fieldState: FloatingTextFieldState): SxProps<Theme> =>
  () => ({
    "& .MuiOutlinedInput-root": {
      ...(fieldState === "success" ? { className: "sefano-success" } : {}),
    },
  });

export const wrapper: SxProps<Theme> = {
  width: "100%",
};
